import React, { FunctionComponent } from 'react'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppRouter, updatePaymentOption, createDocuments } from '../../../state'
import { PaymentOption } from '../../../model'
import { Button } from '@afterpaytouch/core'
import { Route } from '../../../config/router'
import { TrackingEvent } from '../../../model/monitoring'
import { useMonitoringWithEnduringEventProperties } from '../../../integrations/monitoring'
import styles from './style.module.css'

interface PaymentOptionsContinueButtonProps {
  selectedPaymentOptionLocal?: PaymentOption
  setPaymentOptionsUpdated: (bool: boolean) => void
  lock: boolean
  setLock: (bool: boolean) => void
}

export const PaymentOptionsContinueButton: FunctionComponent<PaymentOptionsContinueButtonProps> = ({
  selectedPaymentOptionLocal,
  setPaymentOptionsUpdated,
  lock,
  setLock,
}) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const router = useAppRouter()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const handleContinueClick = async (): Promise<void> => {
    setLock(true)
    logEvent(TrackingEvent.PRESSED_CL_PLAN_PAGE_CONTINUE_BUTTON, { paymentOption: selectedPaymentOptionLocal })
    if (typeof selectedPaymentOptionLocal !== 'undefined') {
      try {
        await dispatch(updatePaymentOption(selectedPaymentOptionLocal.id)).unwrap()
        await dispatch(createDocuments({ autopay: true })).unwrap()
        setPaymentOptionsUpdated(true)
      } catch (e) {
        router.push(Route.TERMINAL_ERROR)
      }
    }
  }

  return (
    <div className={styles.continueButton}>
      <Button
        loading={lock}
        padding='Fluid'
        onClick={handleContinueClick}
        testNameSpace='payment-options'
        disabled={typeof selectedPaymentOptionLocal === 'undefined' || lock}
      >
        {t('consumerLending:paymentOptions:continue')}
      </Button>
    </div>
  )
}
